// @ts-strict

import { Pipe, PipeTransform } from '@angular/core';
import { IOrderedTraslantedCountry } from '../components/countries-checkbox-list/countries-checkbox-list.component';

/**
 * @ngModule SharedModule
 * @description
 *
 * Filters countries array to return searched value
 *
 * @usageNotes
 *
 * Usage:
 *   array | searchCountry:ngModel
 * Example:
 *   {{ countries | searchCountry:search }}
 *   returns search which is value binded by ngModel with input
 */

@Pipe({
  name: 'searchCountry'
})
export class SearchCountryPipe implements PipeTransform {
  transform(value: IOrderedTraslantedCountry[], searchValue: string) {
    if (!searchValue) {
      return value;
    }
    return value.filter(v => v.translatedName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
  }
}
